module.exports = __webpack_public_path__ + "img/1F1F8-1F1E8.29d62d07.svg";